<template>
<Card shadow style="min-height: 700px;margin: 10px 0;">
  <Breadcrumb>
    <BreadcrumbItem>开票完成</BreadcrumbItem>
  </Breadcrumb>
  <div class="invoice-wrap">
    <div>
      <img src="@/assets/egis.png" alt="">
      <h2 class="invoice-title">申请通过，开票中</h2>
      <Button @click="isBack" style="margin-right: 20px">返回</Button>
      <Button @click="viewRecords">查看开票记录</Button>
    </div>
  </div>
</Card>
</template>

<script>
export default {
  name: 'invoice-end',
  data () {
    return {

    }
  },
  methods: {
    isBack () {
      this.$router.push('/order/create-invoice')
    },
    viewRecords () {
      this.$router.push('/order/invoice')
    }
  }
}
</script>

<style scoped>
.invoice-wrap{
  display: flex;
  flex-direction: row;
  justify-content: center;
  height: 100%;
  text-align: center;
  min-height: 680px;
  align-items: center;
}
.invoice-title{
  margin: 20px 0;
}
</style>
